import React, { useState } from 'react'
import ProjectStep from "../components/ProjectStep";
import { generatePath } from "react-router-dom";
import { Input, Radio } from 'antd'
import { useProjectForm } from "../../../providers/ProjectFormProvider";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';
import TeamBlueprint from "../components/TeamBlueprint";


const PhaseDeliverables = (props) => {
    const {
        formModel: project,
        isProjectUpdating,
    } = useProjectForm();

    const isDisabled = props.isDisabled || isProjectUpdating;

    const [affix, setAffix] = useState(false);

    const desiredDeliverables = TB.filter(TB.flatMap(TB.flatMap(project.phases, 'deliverables')), del => del.is_desired !== false)

    const matchedProjectDisciplines = TB.orderBy(TB.reduce(desiredDeliverables, (result, deliverable) => {
        TB.map(TB.flatMap(deliverable.activities, 'disciplines'), dis => {
            if (!TB.find(result, ['id', dis.id])) {
                result.push({
                    ...dis,
                    deliverable_id: deliverable.id
                })
            }
        })
        return result;
    }, []), 'name')
    const matchedProjectSkills = TB.orderBy(TB.reduce(desiredDeliverables, (result, deliverable) => {
        TB.map(deliverable.skills, skill => {
            if (!TB.find(result, ['id', skill.id])) {
                result.push({
                    ...skill,
                    deliverable_id: deliverable.id
                })
            }
        })
        return result;
    }, []), 'name')

    const allDeliverableSkillsById = TB.groupBy(TB.flatMap(desiredDeliverables, 'skills'), 'id');

    const onChangeDeliverable = (phaseIndex, deliverableIndex, deliverableProps) => {
        let formModel = TB.pick(project, ['phases', 'skills', 'disciplines']);
        let deliverableModel = TB.get(formModel, `phases[${phaseIndex}].deliverables[${deliverableIndex}]`);


        const desiredSkillsById = TB.filter(deliverableModel.skills, skill => !!skill);

        let projectSkills = [...(project.skills || [])];
        const isDesired = deliverableProps.is_desired !== false;


        TB.map(desiredSkillsById, skill => {
            let match = TB.find(projectSkills, ['id', skill.id]);
            if (isDesired && !match) {
                projectSkills.push(skill)
            } else if (!isDesired && match) {
                if (allDeliverableSkillsById[skill.id]?.length <= 1) {
                    projectSkills = TB.reject(projectSkills, ['id', skill.id]);
                }
            }
        })

        formModel.skills = projectSkills;

        formModel = TB.set(
            formModel,
            `phases[${phaseIndex}].deliverables[${deliverableIndex}]`,
            { ...deliverableModel, ...deliverableProps }
        );

        return props.onChange(formModel)
    }

    const deliverableOptions = {
        yes: true,
        unsure: null,
        no: false,
    }


    return (
        <div className="flex flex-col items-stretch gap-6 relative phase-deliverables">
            {TB.map(project?.phases || [], (phase, phaseIndex) => {

                return (
                    <div key={`phase-${phase.id}`} className="bg-light-gray3 px-5 py-8">
                        <p className="text-lg font-semibold text-black mb-8">
                            Phase #{phaseIndex + 1}: {phase.name}
                        </p>

                        <div className="flex flex-col items-stretch gap-8">
                            {TB.map(phase.deliverables || [], (deliverable, deliverableIndex) => {

                                const isSelected = deliverable.is_desired;
                                const matchedDisciplines = TB.orderBy(TB.filter(matchedProjectDisciplines, ['deliverable_id', deliverable.id]), 'id', 'desc');
                                const matchedSkills = TB.orderBy(TB.filter(matchedProjectSkills, ['deliverable_id', deliverable.id]), 'id', 'desc');

                                const updatedForProjectTeam = isSelected && (matchedDisciplines.length > 0 || matchedSkills.length > 0)
                                return (
                                    <div key={`phase-${phase.id}-d-${deliverable.id}`}
                                        className="flex flex-col items-stretch divide-y">

                                        <div className="flex flex-row items-stretch divide-x bg-white">
                                            <div
                                                className="lg:basis-[30%] flex flex-col gap-2 px-5 py-5 justify-start">
                                                <p className="font-semibold">
                                                    {deliverable.name}
                                                </p>

                                                <p className="text-xxs pr-5">
                                                    {deliverable.description}
                                                </p>
                                            </div>

                                            <div
                                                className="lg:basis-[30%] flex flex-col gap-2 px-5 py-5 justify-start">
                                                {deliverable.is_required ? (
                                                    <React.Fragment>
                                                        <p className="font-semibold">
                                                            Include?
                                                        </p>

                                                        <div className="flex gap-3">
                                                            <Radio.Group
                                                                value="Required"
                                                                buttonStyle="solid"
                                                                // disabled={true}
                                                                name={`phases[${phaseIndex}].deliverables[${deliverableIndex}].is_required`}
                                                            >
                                                                <Radio.Button value="Required">Yes</Radio.Button>
                                                            </Radio.Group>

                                                            <p className="text-xs text-gray-500">
                                                                This deliverable is required for this project type
                                                            </p>
                                                        </div>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <p className="font-semibold">
                                                            Include?
                                                        </p>

                                                        <Radio.Group
                                                            value={TB.invert(deliverableOptions)[deliverable.is_desired]}
                                                            // defaultValue="yes"
                                                            buttonStyle="solid"
                                                            disabled={isDisabled}
                                                            onChange={e => {
                                                                if (isDisabled) return;

                                                                if (desiredDeliverables?.length === 1 && deliverableOptions[e.target.value] === false) {
                                                                    return TB.toast('At least one deliverable is required', { theme: 'danger' })
                                                                }
                                                                return onChangeDeliverable(
                                                                    phaseIndex,
                                                                    deliverableIndex,
                                                                    { is_desired: deliverableOptions[e.target.value] }
                                                                )
                                                            }}
                                                            name={`phases[${phaseIndex}].deliverables[${deliverableIndex}].is_desired`}>
                                                            <Radio.Button value="yes">Yes</Radio.Button>
                                                            <Radio.Button value="unsure">Unsure</Radio.Button>
                                                            <Radio.Button value="no">No</Radio.Button>
                                                        </Radio.Group>
                                                    </React.Fragment>
                                                )}
                                            </div>

                                            <div
                                                className="lg:basis-[40%] flex flex-col gap-2 px-5 py-5 justify-start">
                                                <p className="font-semibold">
                                                    Add notes
                                                </p>

                                                <Input.TextArea
                                                    value={deliverable.client_comments || ''}
                                                    name={`phases[${phaseIndex}].deliverables[${deliverableIndex}].client_comments`}
                                                    placeholder="Type your note here."
                                                    autoSize={{ maxRows: 6, minRows: 1 }}
                                                    showCount
                                                    disabled={isDisabled}
                                                    maxLength={500}
                                                    onChange={e => {
                                                        if (isDisabled) return;

                                                        return onChangeDeliverable(
                                                            phaseIndex,
                                                            deliverableIndex,
                                                            { client_comments: e.target.value }
                                                        )
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="flex flex-row items-stretch divide-x bg-white">

                                            <div
                                                className="lg:basis-[100%] px-5 py-5 flex flex-col gap-6 items-stretch justify-center">

                                                <div>
                                                    {isSelected === true ? (
                                                        <p className="text-sm flex flex-row items-center gap-2">
                                                            <i className="fas fa-check-circle text-success text-[18px]" />
                                                            <span>
                                                                {updatedForProjectTeam ? (
                                                                    (matchedSkills?.length > 0 && matchedDisciplines?.length > 0) ? `Adding ${TB.pluralize("team role", matchedDisciplines.length, true)} and ${TB.pluralize("skill", matchedSkills.length, true)} for this deliverable` :
                                                                        (matchedSkills?.length > 0) ? `Adding ${TB.pluralize("team skill", matchedSkills.length, true)} for this deliverable` :
                                                                            `Adding ${TB.pluralize("team role", matchedDisciplines.length, true)} for this deliverable`
                                                                ) : "Recommended roles & skills already included in team blueprint"}
                                                            </span>
                                                        </p>
                                                    ) : (isSelected === false ? (
                                                        <p className="text-sm flex flex-row items-center gap-2">
                                                            <i className="fas fa-times-circle text-gray-400 text-[18px]" />
                                                            <span>
                                                                No team roles or skill requirements are being added for
                                                                this specific deliverable
                                                            </span>
                                                        </p>
                                                    ) : (
                                                        <p className="text-sm flex flex-row items-center gap-2">
                                                            <i className="fas fa-question-circle text-gray-400 text-[18px]" />
                                                            <span>
                                                                We'll add team roles and skills for this deliverable
                                                                until you decide.
                                                            </span>
                                                        </p>
                                                    ))}
                                                </div>


                                                {(matchedDisciplines?.length > 0 || matchedSkills?.length > 0) && (
                                                    <div className="flex flex-row items-start gap-4">
                                                        {matchedDisciplines?.length > 0 && (
                                                            <div
                                                                className="basis-1/2 flex-row flex justify-start flex-nowrap items-start self-stretch relative gap-4">
                                                                <p className="text-[11px] h-[28px] font-medium text-gray-400 leading-[28px]">
                                                                    Roles
                                                                </p>
                                                                <div
                                                                    className="flex flex-row flex-wrap gap-x-2 gap-y-1.5">
                                                                    {TB.map(matchedDisciplines, dis => (
                                                                        <p key={`del-${deliverable.id}-dis-${dis.id}`}
                                                                            className={TB.mapClass("h-[28px] border text-xs rounded-full px-2.5 inline-flex flex-row items-center flex-nowrap gap-1.5", {
                                                                                "bg-white border-gray-400": isSelected !== false,
                                                                                "bg-[#d3d8dd] border-[#d3d8dd]": isSelected === false
                                                                            })}
                                                                        >
                                                                            <i className={TB.mapClass("fas fa-user text-[14px]", {
                                                                                "text-success": isSelected !== false,
                                                                                "text-[#6d6d6d]": isSelected === false,
                                                                            })} />
                                                                            <span
                                                                                className={isSelected === false ? 'text-[#6d6d6d]' : ''}>
                                                                                {dis.name}
                                                                            </span>
                                                                        </p>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {matchedSkills?.length > 0 && (
                                                            <div
                                                                className="basis-1/2 project-skills-container flex flex-row justify-start items-start flex-nowrap self-stretch relative gap-4">
                                                                <p className="text-[11px] h-[28px] font-medium text-gray-400 leading-[28px]">
                                                                    Skills
                                                                </p>
                                                                <div className="relative discipline-skills-container skill-importance-container gap-3">
                                                                    {TB.map(matchedSkills, skill => (
                                                                        <NEWSkillFormButton
                                                                            key={`del-${deliverable.id}-dis-${skill.name}`}
                                                                            skill={skill}
                                                                            // className={' '}
                                                                            valuePropName={'importance'}
                                                                            disabled
                                                                            readonly
                                                                            scoringOptions={laravel.importance_levels}
                                                                            className="min-w-[115px]"
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
export default class PhaseDeliverablesStep extends ProjectStep {
    static TranslationKey = 'deliverables_step';

    static path = '/deliverables';
    static slug = 'deliverables';

    static HandleUnauthorized = false;

    static Optional = false;

    static ValidationMethodName = 'validateDeliverables';

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        }
    }


    /**
     * The continue & back buttons
     */
    static showFormButtons() {
        return false
    }

    getStepName() {
        return false
    }

    /**
     * The subtitle shown on the form
     */
    getStepSubtitle() {

        return ``;
    }

    static hasCompleted(project) {
        return project.validateDeliverables();
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(project) {
        return false
    };

    static getPath(project) {
        let projectId = TB.isObject(project) ? project.id : project;


        return generatePath(`${TB.routes().clientProjectSetup}${this.path}`, {
            projectId
        })
    }

    render() {

        return (
            <div className="flex flex-col items-stretch gap-4">
                <TeamBlueprint components={{ roles: true, skills: true }}>
                    <p className="px-4 py-3 flex flex-row items-center justify-center gap-2">
                        <i className="fas fa-check-circle text-success text-[15px]" />
                        <span>
                            Based upon other <span className="uppercase font-semibold">{this.props.project.template?.name}</span> projects, we’ve created the initial roles and skills required for your project team!
                        </span>
                    </p>
                </TeamBlueprint>
                <div className="wizard-form-step project-team-step">

                    <div className="flex flex-col items-stretch">
                        <div className="flex flex-row justify-between items-center pb-5">
                            <div>
                                <p className="text-xl font-medium text-left text-black">
                                    What deliverables do you need?
                                </p>

                                <p className="text-sm text-left text-black">
                                    Based upon your project type, we’ve included the most common set of deliverables
                                    requested.
                                </p>
                            </div>
                            {!this.props.shouldBeRedirected() && (
                                <p className="flex flex-col gap-1 justify-center text-center">
                                    <span className="text-xs text-center text-black">
                                        Rather discuss on a call?
                                    </span>
                                    <span onClick={() => {
                                        if (this.props.isDisabled) {
                                            return
                                        }
                                        return this.props.goToNextStep()
                                    }} className="clickable text-base underline font-semibold text-center text-primary">
                                        SKIP THIS STEP
                                    </span>
                                </p>
                            )}
                        </div>
                        <PhaseDeliverables
                            isDisabled={this.props.isDisabled} onChange={this.props.onChange} />

                        <div className="mt-5 flex flex-col items-stretch">
                            {this.props.children}
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}